import store from "../store/store";

const getTheUserState = () => {
  const state = store.getState();
  return state?.auth?.user;
};

export default getTheUserState;
